export default __webpack_public_path__ + "static/ajanlat-f50f84cfd72a75caadf6fe47c72a8ba8.pdf";